import React from "react";
import {
  GridToolbarQuickFilter,
  useGridApiContext,
  gridFilteredSortedRowIdsSelector,
  gridVisibleColumnFieldsSelector,
} from "@mui/x-data-grid";
import { Button, Box } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import * as XLSX from "xlsx";

const CustomDataGridToolbar = ({
  columns,
  fileName,
  name,
  isExportToExcelRequired,
}) => {
  const apiRef = useGridApiContext();

const handleExportExcel = () => {
  const selectedRowMap = apiRef.current.getSelectedRows();

  let rowIds = [];

  // 1. Export selected rows first
  if (selectedRowMap.size > 0) {
    rowIds = Array.from(selectedRowMap.keys());
  }

  // 2. Else export filtered/searched rows
  else {
    const filteredIds = gridFilteredSortedRowIdsSelector(apiRef);

    // if filter/search applied
    if (
      filteredIds.length > 0 &&
      filteredIds.length !== apiRef.current.getRowsCount()
    ) {
      rowIds = filteredIds;
    }

    // 3. Else export all rows
    else {
      rowIds = gridFilteredSortedRowIdsSelector(apiRef);
    }
  }

  const visibleFields = gridVisibleColumnFieldsSelector(apiRef);

  const exportColumns = columns.filter(
    (col) =>
      visibleFields.includes(col.field) &&
      col.hide !== true &&
      col.field !== "actions" &&
      col.field !== "__check__"
  );

  const worksheetData = rowIds.map((id) => {
    const data = {};

    exportColumns.forEach((col) => {
      let value = apiRef.current.getCellParams(id, col.field).value;

      // Preserve number type
      if (col.type === "number") {
        value =
          value === null || value === undefined || value === ""
            ? null
            : Number(value);
      }

      data[col.headerName] = value ?? "";
    });

    return data;
  });

  const worksheet = XLSX.utils.json_to_sheet(worksheetData);

  // Apply Excel types
  exportColumns.forEach((col, index) => {
    const colLetter = XLSX.utils.encode_col(index);

    for (let row = 2; row <= worksheetData.length + 1; row++) {
      const cellAddress = `${colLetter}${row}`;
      const cell = worksheet[cellAddress];

      if (!cell) continue;

      // Date type
      if (col.type === "date" && cell.v instanceof Date) {
        cell.t = "d";
        cell.z = "dd/mm/yyyy";
      }

      // Number type
      if (col.type === "number") {
        cell.t = "n";
      }
    }
  });

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Data");

  XLSX.writeFile(workbook, fileName || "Payment.xlsx");
};

  return (
    <>
      <Box sx={{ p: 0.5, pb: 0, float: "right" }}>
        <GridToolbarQuickFilter />
      </Box>

      {isExportToExcelRequired && (
        <Box sx={{ p: 0.5, pb: 0, float: "left" }}>
          <Button startIcon={<DownloadIcon />} onClick={handleExportExcel}>
            {name || "Export to Excel"}
          </Button>
        </Box>
      )}
    </>
  );
};
export default CustomDataGridToolbar;